module.exports = ".adjustment-list .adjustment {\n  border: 1px solid #ccc;\n  background-color: #f8f8f8;\n  height: 30px;\n  margin-top: -1px;\n  margin-left: -1px; }\n\n.positive {\n  color: green;\n  font-weight: bold; }\n\n.negative {\n  color: red;\n  font-weight: bold; }\n\n.modal {\n  display: block !important; }\n\n.modal-dialog {\n  overflow-y: initial !important; }\n\n.modal-body {\n  height: 400px;\n  overflow-y: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/report/adjustments/components/view-adjustments.modal.component.scss
// module id = ./src/app/report/adjustments/components/view-adjustments.modal.component.scss
// module chunks = main